import { useState } from "react";
import { useRunAnalysis } from "@/sdk/hooks/use-scanner";
import { Panel } from "@/components/panel";
import { LoadingState } from "@/components/loading-state";

// OVERLAP NOTE: this panel duplicates much of
// features/analysis/components/AnalysisPanel.tsx (same useRunAnalysis hook,
// same mode picker, same raw-JSON output). Consolidating the two is a
// capability-surface change and therefore needs explicit Hans approval
// (CLAUDE.md Gate 2) — do NOT fold one into the other as a drive-by refactor.

type AnalysisMode = "quick" | "standard" | "deep" | "debate";

export function PredictivePanel() {
  const [marketId, setMarketId] = useState("");
  const [mode, setMode] = useState<AnalysisMode>("standard");
  const run = useRunAnalysis();
  const result = run.data as Record<string, unknown> | undefined;
  return (
    <Panel title="Predictive Engine">
      <div className="space-y-3">
        <input className="w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-sm text-white placeholder-white/30 focus:outline-none" placeholder="Market ID..." value={marketId} onChange={e => setMarketId(e.target.value)} />
        <div className="flex items-center gap-2">
          <select title="Analysis mode" className="rounded border border-white/10 bg-white/5 px-2 py-1.5 text-xs text-white/70 focus:outline-none" value={mode} onChange={e => setMode(e.target.value as AnalysisMode)}>
            {(["quick","standard","deep","debate"] as AnalysisMode[]).map(m => <option key={m} value={m}>{m}</option>)}
          </select>
          <button type="button" onClick={() => run.mutate({ market_id: marketId, mode })} disabled={run.isPending || !marketId} className="px-3 py-1.5 rounded bg-blue-600 hover:bg-blue-500 disabled:opacity-50 text-xs text-white">
            {run.isPending ? "Analysing…" : "Analyse"}
          </button>
        </div>
        {run.isPending && <LoadingState text={`Running ${mode} analysis…`} />}
        {run.isError && (
          <p className="text-sm text-red-400">
            Analysis failed: {run.error instanceof Error ? run.error.message : "request error"}
          </p>
        )}
        {result && (
          <pre className="text-xs text-white/60 bg-white/5 rounded p-3 overflow-auto max-h-80 leading-relaxed">{JSON.stringify(result, null, 2)}</pre>
        )}
      </div>
    </Panel>
  );
}
